<template>
  <div
    class="inline-flex items-center px-2.5 mr-1"
    :class="{
      'rounded-full cursor-pointer border-transparent hover:text-white hover:bg-gray-500':
        isClickable,
    }"
    @click="handleClick"
    v-tippy="{
      content: isClickable ? `Back to ${phaseData.title.toLowerCase()}` : '',
      theme: 'light-border',
      interactive: true,
    }"
  >
    <span
      class="
        inline-flex
        justify-center
        items-center
        prose-sm
        font-bold
        w-10.5
        h-10.5
        mr-2.5
        border-2 border-vice-teal-400
        rounded-full
      "
    >
      <CheckIcon class="w-5 h-5 text-vice-teal-400" />
    </span>
    <div class="flex flex-col">
      <span class="text-sm font-medium leading-5">{{ phaseData.title }}</span>
      <span class="text-sm font-medium leading-5">{{ formatedDuration }}</span>
    </div>
  </div>
</template>

<script>
import { CheckIcon } from '@heroicons/vue/solid';

// TODO: Move imports to timeFormatter composable
import { computed } from 'vue';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { directive } from 'vue-tippy';
import { VICE_SESSION_PHASES } from '@/Utils/vice-constants';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light-border.css';

dayjs.extend(duration);

export default {
  directives: {
    tippy: directive,
  },
  props: {
    isClinician: {
      type: Boolean,
      required: true,
    },
    phaseData: {
      type: Object,
      required: true,
    },
    currentPhase: {
      type: Number,
      required: true,
    },
    livePhase: {
      type: Object,
    },
    hasLivePhase: {
      type: Boolean,
      required: true,
    },
    backToPreviousPhase: {
      type: Function,
    },
  },
  components: {
    CheckIcon,
  },
  setup(props) {
    const isClickable = computed(
      () =>
        props.isClinician &&
        props.hasLivePhase &&
        (props.currentPhase === VICE_SESSION_PHASES.CONSULTATION ||
          (props.currentPhase === VICE_SESSION_PHASES.INTRODUCTION &&
            props.phaseData.id === VICE_SESSION_PHASES.CONSULTATION) ||
          (props.currentPhase === VICE_SESSION_PHASES.DEBRIEF &&
            props.phaseData.id === VICE_SESSION_PHASES.CONSULTATION)),
    );

    // TODO: Move method to timeFormatter composable and fix issue where checking prop type is neccessary
    const formatedDuration = computed(() =>
      dayjs.duration(props.phaseData.duration).format('H:mm:ss'),
    );

    const handleClick = () => {
      if (isClickable.value) {
        props.backToPreviousPhase(props.livePhase);
      }
    };

    return {
      isClickable,
      handleClick,
      formatedDuration,
    };
  },
};
</script>
